import { useCallback, useMemo } from "react";
import { useSearchParams } from "next/navigation";

export const formatSearchParamsToString = (record: Record<string, any>) => {
    return Object.entries(record)
        .filter(([_, v]) => v !== undefined && v !== null)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join("&");
};

export const useSearchParamsQuery = () => {
    const searchParams = useSearchParams();

    const query = useMemo(() => {
        const q: Record<string, string> = {};
        searchParams?.forEach((value, key) => {
            q[key] = value;
        });
        return q;
    }, [searchParams]);

    const getQueryString = useCallback(
        (newQuery?: Record<string, string>) => {
            return formatSearchParamsToString({ ...query, ...newQuery });
        },
        [query],
    );

    return { query, searchParams, getQueryString };
};
